import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import CustomSelect from '../../../CustomReactSelectComponent'
import InputGroup from '../../../InputGroup'
import PhoneNumber from '../../../CustomNumberFormat'
import Switcher from '../../../CustomSwitchComponent'
import { Row, Col, Button, Form } from 'reactstrap'
import { FINANCE_DEALER_FILTERS } from '../../../../constants/contactFilterCategory'

const FilterInputsFinanceDealers = ({
  selectedFilters,
  handleFiltersChanges,
  loadData,
  setFiltersValue,
  removeFilter,
  selectedFiltersValues,
  getOptions,
  options,
}) => {
  const [data, setData] = useState({})
  const dispatch = useDispatch()

  useEffect(() => {
    getOptions(FINANCE_DEALER_FILTERS)
  }, [])

  useEffect(() => {
    handleFilterDispatching('source_id', data.source_id)
  }, [data.source_id])

  useEffect(() => {
    handleFilterDispatching('cd.dealership_type_id', data.dealership_type_id, 'dealership_type_id')
  }, [data.dealership_type_id])

  useEffect(() => {
    handleFilterDispatching('address_state', data.address_state)
  }, [data.address_state])

  useEffect(() => {
    handleFilterDispatching('created_by', data.created_by)
  }, [data.created_by])

  useEffect(() => {
    const mappedValues = mapRedFlagStatusIds()
    handleFilterDispatching('red_flag.status', mappedValues, 'red_flag_status')
  }, [data.red_flag_status])

  useEffect(() => {
    handleFilterDispatching('red_flag.flagged_by', data.red_flag_flagged_by, 'red_flag_flagged_by')
  }, [data.red_flag_flagged_by])

  useEffect(() => {
    handleFilterDispatching('red_flag.division_id', data.red_flag_division_id, 'red_flag_division_id')
  }, [data.red_flag_division_id])

  useEffect(() => {
    handleFilterDispatching('nationality_id', data.nationality_id)
  }, [data.nationality_id])

  useEffect(() => {
    handleFilterDispatching('divisions.assigned', data.salesperson, 'salesperson')
  }, [data.salesperson])

  useEffect(() => {
    handleFilterDispatching('divisions.grade', data.grade, 'grade')
  }, [data.grade])

  const handleFilterDispatching = (filterName, filterValues, localFilterName = filterName) => {
    if (data[localFilterName]?.length > 0) {
      dispatch(setFiltersValue(filterName, filterValues))
    } else if (data[localFilterName]?.length === 0) {
      dispatch(removeFilter(filterName))
    }
  }

  const mapRedFlagStatusIds = () => {
    const { red_flag_status } = data
    const mappedValues = []

    if (red_flag_status?.length > 0) {
      red_flag_status.forEach((id) => mappedValues.push(id === 94 ? 2 : 1)) //94 Closed
    }

    return mappedValues
  }

  const handleSelectChange = (values, e, isMulti, isLoadCost) => {
    const { name } = e
    if (isMulti) {
      if (values) {
        const newValues = []
        values.forEach((value) => {
          newValues.push(isLoadCost ? value.value : value.id)
        })
        setData({ ...data, [name]: newValues })
      } else {
        setData({ ...data, [name]: [] })
      }
    } else {
      setData({ ...data, [name]: values ? values.value : null })
    }
  }

  return (
    <>
      <Form noValidate onSubmit={() => loadData()}>
        <Row className='mt-3 filterInputs'>
          {selectedFilters.name && (
            <Col xs={3}>
              <InputGroup
                label='Name'
                type='text'
                name='name'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.name}
              />
            </Col>
          )}
          {selectedFilters.mc_number && (
            <Col xs={3}>
              <InputGroup
                label='MC Number'
                type='text'
                name='mc_number'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.mc_number}
              />
            </Col>
          )}
          {selectedFilters.primary_contact && (
            <Col xs={3}>
              <InputGroup
                label='Primary Contact'
                type='text'
                name='cd.primary_contact'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues['cd.primary_contact']}
              />
            </Col>
          )}
          {selectedFilters.dealership_type_id && (
            <Col xs={3}>
              <CustomSelect
                label='Dealership Type'
                name='dealership_type_id'
                defaultValue={data?.dealership_type_id || []}
                isMulti
                isClearable
                onChange={(values, event) => handleSelectChange(values, event, true)}
                options={options.DealershipType || []} // Need Company type
              />
            </Col>
          )}
          {selectedFilters.address_state && (
            <Col xs={3}>
              <CustomSelect
                label='State'
                name='address_state'
                defaultValue={data?.address_state || []}
                isMulti
                isClearable
                options={options.States || []}
                onChange={(values, event) => handleSelectChange(values, event, true)}
              />
            </Col>
          )}
          {selectedFilters.estimated_revenue && (
            <>
              <Col xs={2}>
                <InputGroup
                  label='Est. revenue from'
                  name='estimated_revenue'
                  type='number'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.estimated_revenue && selectedFiltersValues.estimated_revenue.from}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Est. revenue to'
                  name='estimated_revenue'
                  type='number'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.estimated_revenue && selectedFiltersValues.estimated_revenue.to}
                />
              </Col>
            </>
          )}
          {selectedFilters.date_established && (
            <>
              <Col xs={2}>
                <InputGroup
                  label='Date Established from'
                  name='date_established'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.date_established && selectedFiltersValues.date_established.from}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Date Established to'
                  name='date_established'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.date_established && selectedFiltersValues.date_established.to}
                />
              </Col>
            </>
          )}
          {selectedFilters.created_by && (
            <Col xs={3}>
              <CustomSelect
                label='Created By'
                name='created_by'
                defaultValue={data?.created_by || []}
                onChange={(values, event) => handleSelectChange(values, event, true)}
                isMulti
                isClearable
                options={options.Users || []}
              />
            </Col>
          )}
          {selectedFilters.red_flag && (
            <>
              <Col xs={3}>
                <CustomSelect
                  label='Red Flag'
                  name='red_flag_status'
                  defaultValue={data?.red_flag_status || []}
                  onChange={(values, event) => handleSelectChange(values, event, true)}
                  isMulti
                  isClearable
                  options={options?.RedFlagstatus || []}
                />
              </Col>
              <Col xs={3}>
                <CustomSelect
                  label='Red Flag User'
                  name='red_flag_flagged_by'
                  defaultValue={data.red_flag_flagged_by || []}
                  onChange={(values, event) => handleSelectChange(values, event, true)}
                  isMulti
                  isClearable
                  options={options.Users || []}
                />
              </Col>
              <Col xs={3}>
                <CustomSelect
                  label='Red Flag Division'
                  name='red_flag_division_id'
                  defaultValue={data.red_flag_division_id || []}
                  onChange={(values, event) => handleSelectChange(values, event, true)}
                  isMulti
                  isClearable
                  options={options.Divisions || []}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Red Flag Date from'
                  name='redflag.creation_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={
                    selectedFiltersValues['redflag.creation_date'] &&
                    selectedFiltersValues['redflag.creation_date'].from
                  }
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Red Flag Date to'
                  name='redflag.creation_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={
                    selectedFiltersValues['redflag.creation_date'] && selectedFiltersValues['redflag.creation_date'].to
                  }
                />
              </Col>
            </>
          )}
          {selectedFilters.salesperson && (
            <Col xs={3}>
              <CustomSelect
                label='Salesperson'
                name='salesperson'
                defaultValue={data?.salesperson || []}
                onChange={(values, event) => handleSelectChange(values, event, true)}
                isMulti
                isClearable
                options={options.Salespersons || []}
              />
            </Col>
          )}
          {selectedFilters.email && (
            <Col xs={3}>
              <InputGroup
                label='Email'
                type='text'
                name='email'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.email}
              />
            </Col>
          )}
          {selectedFilters.dot_number && (
            <Col xs={3}>
              <InputGroup
                label='DOT Number'
                type='text'
                name='dot_number'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.dot_number}
              />
            </Col>
          )}
          {selectedFilters.business_phone && (
            <Col xs={3}>
              <PhoneNumber
                label='Business Phone'
                className={'form-control-sm form-control'}
                name='business_phone'
                value={selectedFiltersValues.business_phone}
                placeholder='Business Phone'
                type='tel'
                format='(999) 999-9999'
                onChange={handleFiltersChanges}
                size={10}
                hidePhoneIcon
              />
            </Col>
          )}
          {selectedFilters.source_id && (
            <Col xs={3}>
              <CustomSelect
                label='Source'
                defaultValue={data?.source_id || []}
                name='source_id'
                isMulti
                isClearable
                options={options.SourceType || []}
                onChange={(values, event) => handleSelectChange(values, event, true)}
              />
            </Col>
          )}
          {selectedFilters.address_zip && (
            <Col xs={3}>
              <InputGroup
                label='Zip Code'
                type='text'
                name='address_zip'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.address_zip}
              />
            </Col>
          )}
          {selectedFilters.grade && (
            <Col xs={3}>
              <CustomSelect
                label='Grade'
                name='grade'
                defaultValue={data?.grade || []}
                onChange={(values, event) => handleSelectChange(values, event, true)}
                isMulti
                isClearable
                options={options.ProspectGrade || []}
              />
            </Col>
          )}
          {selectedFilters.creation_date && (
            <>
              <Col xs={2}>
                <InputGroup
                  label='Date Entered from'
                  name='creation_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.creation_date && selectedFiltersValues.creation_date.from}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Date Entered to'
                  name='creation_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.creation_date && selectedFiltersValues.creation_date.to}
                />
              </Col>
            </>
          )}
          {selectedFilters.last_contact_date && (
            <>
              <Col xs={2}>
                <InputGroup
                  label='Last Contact Date from'
                  name='last_contact_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.last_contact_date && selectedFiltersValues.last_contact_date.from}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Last Contact Date to'
                  name='last_contact_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.last_contact_date && selectedFiltersValues.last_contact_date.to}
                />
              </Col>
            </>
          )}
          {selectedFilters.out_of_business && (
            <Col xs={3}>
              <Switcher
                labelName='Out Of Bussines'
                name='out_of_business'
                checked={selectedFiltersValues.out_of_business}
                onChange={(event) => handleFiltersChanges(event)}
              />
            </Col>
          )}
          {selectedFilters?.nationality_id && (
            <Col xs={3}>
              <CustomSelect
                label='Preferred Language'
                name='nationality_id'
                isMulti
                isClearable
                options={options.Nationality || []}
                defaultValue={data?.nationality_id || []}
                onChange={(values, event) => handleSelectChange(values, event, true)}
              />
            </Col>
          )}
        </Row>
      </Form>
      <Row className='flex-row-reverse mr-3'>
        <Button className={'btn btn-gold'} type='submit' onClick={() => loadData()}>
          Search
        </Button>
      </Row>
    </>
  )
}

FilterInputsFinanceDealers.propTypes = {
  selectedFilters: PropTypes.object.isRequired,
  selectedFiltersValues: PropTypes.object,
  handleFiltersChanges: PropTypes.object.isRequired,
  loadData: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  getOptions: PropTypes.func.isRequired,
}

FilterInputsFinanceDealers.defaultProps = {
  selectedFiltersValues: {},
}

export default FilterInputsFinanceDealers
